import { ChevronBackIcon } from '../../icons/ChevronBackIcon';
import { StyledBackButton } from './BackButton.styles';
import type { BackButtonProps } from './BackButton.types';

export function BackButton({
  onClick,
  variant = 'default',
  ariaLabel = 'Go back',
  disabled = false,
}: BackButtonProps) {
  return (
    <StyledBackButton
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      data-variant={variant}
      disabled={disabled}
    >
      <ChevronBackIcon />
    </StyledBackButton>
  );
}
